import React, { useEffect, useState } from "react";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import { getRolesApi, createRoleApi, updateRoleApi, deleteRoleApi } from "../../services/apis/builderUserApis";
import { handleApiError } from "../../services/axiosService";
import { toastSuccess } from "../../utils/toastUtils";
import { useModalContext } from "../../context/ModalContext";
import Loader from "../../Layouts/Loader/Loader";
import Input from "../../components/FormComponents/Input";
import Button from "../../components/FormComponents/Button";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";

const UserRole = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openRolesModal = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <Button variant="secondary" onClick={openRolesModal}>
        Role
      </Button>
      <BuilderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} modalName="Roles">
        <RolesModal />
      </BuilderModal>
    </>
  );
};

const RolesModal = () => {
  const [enteredRoleName, setEnteredRoleName] = useState("");
  const [allRolesData, setAllRolesData] = useState([]);

  const { getUserConfirmationForDelete } = useModalContext();
  const [isLoader, setIsLoader] = useState(false);

  const fetchAllRoles = async () => {
    try {
      setIsLoader(true);
      const response = await getRolesApi();
      setAllRolesData(response.data);
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoader(false);
    }
  };

  const addRole = async () => {
    if (!enteredRoleName.trim()) return;

    try {
      const response = await createRoleApi({
        name: enteredRoleName
      });

      const { message, data } = response.data;

      setAllRolesData([...allRolesData, data]);
      setEnteredRoleName("");
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  const editRole = async (id, name) => {
    try {
      const response = await updateRoleApi(id, {
        name: name
      });

      setAllRolesData((prevRoles) => prevRoles.map((role) => (role.id === id ? { ...role, name: name } : role)));

      toastSuccess(response.data.message);
    } catch (error) {
      handleApiError(error);
    }
  };

  const deleteRole = async (id, name) => {
    try {
      const userConfirmed = await getUserConfirmationForDelete(name);
      if (!userConfirmed) return;

      const response = await deleteRoleApi(id);

      setAllRolesData((prevRoles) => prevRoles.filter((role) => role.id !== id));

      toastSuccess(response.data.message);
    } catch (error) {
      handleApiError(error);
    }
  };

  useEffect(() => {
    fetchAllRoles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="inline_tag_items">
        <Input
          value={enteredRoleName}
          onChange={(e) => setEnteredRoleName(e.target.value)}
          placeholder="Enter Role Name"
        />
        <Button onClick={addRole}>+ Add</Button>
      </div>
      <div className="pt_3">
        {isLoader ? (
          <Loader width={30} />
        ) : (
          allRolesData.length > 0 &&
          allRolesData.map((role) => (
            <SingleRoleHandler key={role.id} role={role} deleteRole={deleteRole} editRole={editRole} />
          ))
        )}
      </div>
    </div>
  );
};

const SingleRoleHandler = ({ role, deleteRole, editRole }) => {
  const [isEditMode, setIsEditMode] = useState({ show: false, name: "" });

  const handleEditRole = (e) => {
    if (e.key === "Enter") {
      editRole(role.id, isEditMode.name);
      setIsEditMode({ show: false, name: "" });
    }
  };

  return (
    <>
      {isEditMode.show ? (
        <Input
          value={isEditMode.name}
          onBlur={() => setIsEditMode({ show: false, name: "" })}
          onKeyDown={handleEditRole}
          onChange={(e) => setIsEditMode({ ...isEditMode, name: e.target.value })}
          placeholder="Edit Role Name"
          autoFocus
        />
      ) : (
        <div className="role_card">
          <div>{role.name}</div>
          <div>
            {role.can_delete && (
              <>
                <MaterialIcon
                  name="delete"
                  className="font_size_xlarge"
                  onClick={() => deleteRole(role.id, role.name)}
                />
                <MaterialIcon
                  name="edit"
                  className="font_size_xlarge"
                  onClick={() =>
                    setIsEditMode({
                      show: true,
                      name: role.name
                    })
                  }
                />
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default UserRole;
